<template>
  <div class="forum">
    <div class="forum-box">
      <div class="left">
        <div class="group-box">
          <p class="title">
            <span>全部圈子</span>
          </p>
          <div class="group">
            <el-row :gutter="42">
              <el-col :span="8" v-for="item in group" :key="item.id">
                <div class="grid-content" @click="toCircle(item.id)">
                  <div class="img">
                    <img :src="item.image" @load="onGroupImageLoad" />
                  </div>
                  <div class="content">
                    <p class="name eps">{{ item.name }}</p>
                    <div class="message">
                      <p class="comment">
                        <span>帖子{{ item.post_num }}</span>
                      </p>
                      <p class="people">
                        <span>成员{{ item.user_num }}</span>
                      </p>
                    </div>
                    <p
                      class="isJoin"
                      @click.stop="toJoin(item.id, item.is_user_add)"
                      v-if="item.is_user_add == 2"
                    >
                      + 加入
                    </p>
                    <!-- <p
                      class="isJoin"
                      @click.stop="toJoin(item.id, item.is_user_add)"
                      v-else
                    >
                      退出
                    </p> -->
                  </div>
                  <!-- <p class="btn">进入</p> -->
                </div>
              </el-col>
            </el-row>
          </div>
          <Empty v-if="group.length == 0" class="empty" title="暂无圈子！" />
          <el-pagination
            v-if="totalPage > 15"
            background
            layout="total, prev, pager, next"
            @current-change="handle_current_change"
            :page-size="limit"
            :current-page="page"
            :total="totalPage"
          ></el-pagination>
        </div>
      </div>
      <div class="right">
        <div
          class="mine m-group"
          :class="{ 'no-mart': $identity.name !== 'student' }"
        >
          <p @click="toMemberCommunity('3')" class="title">
            我的圈子
            <span>更多</span>
            <i></i>
          </p>
          <p class="no-login" v-if="$store.state.token && !myGroup.length">
            <span class="emptyTip">暂无圈子～</span>
          </p>
          <router-link
            v-if="!$store.state.token"
            class="no-login"
            :to="{ name: 'Login' }"
          >
            登录后才能查看哦～
          </router-link>
          <div v-else class="login">
            <router-link
              v-for="item in myGroup"
              :key="item.group_id"
              class="grid-content"
              :to="{ name: 'CommunityGroupShow', params: { id: item.id } }"
            >
              <div class="img">
                <img :src="item.image" />
              </div>
              <div class="content">
                <p class="name">{{ item.name }}</p>
                <div class="message">
                  <p class="comment">
                    <span>帖子{{ item.post_num }}</span>
                  </p>
                  <p class="people">
                    <span>成员{{ item.user_num }}</span>
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <SectionRight
          :recommend="myCollect"
          title="我的收藏"
          showMore
          @toOtherDetail="toOther"
          @seeMore="toMemberCommunity('2')"
          tip="暂无收藏~"
        />
        <SectionRight
          :recommend="myPost"
          title="我的帖子"
          showMore
          @toOtherDetail="toOther"
          @seeMore="toMemberCommunity"
          class="myPost"
          tip="暂无帖子~"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SectionRight from "./components/SectionRight";
export default {
  components: { SectionRight },
  name: "Course",
  data() {
    return {
      group: [], //小组列表
      topicCount: {}, //话题数量
      myGroup: [], //我的小组
      myPost: [], //我的参与
      myCollect: [], //我的收藏
      totalPage: 0, //分页话题总数
      page: 1, //分页当前分页
      limit: 15, //分页限制
    };
  },
  async created() {
    await this.getPostNum();
    await this.getGroupList();
    if (this.$store.state.token) {
      await this.getMineGroup();
      await this.getMinePost();
      await this.getMineCollect();
    }
  },
  mounted: function () {},
  methods: {
    // 获取小组列表
    async getGroupList() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/group`,
        {
          page: that.page,
          limit: that.limit,
        },
      );
      that.group = data.data;
      that.totalPage = data.total;
    },
    // 分页加载数据
    handle_current_change(val) {
      this.page = val;
      this.getGroupList();
    },
    // 获取发布数量
    async getPostNum() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/post/statistics`,
      );
      that.topicCount = data;
    },

    // 获取我的小组
    async getMineGroup() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/myGroup`,
      );
      that.myGroup = data.data.splice(0, 5);
    },

    // 获取我的帖子
    async getMinePost(limit) {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/myPost`,
        {
          page: 1,
          limit: limit ? limit : 5,
        },
      );
      that.myPost = data.data.splice(0, 5);
    },

    // 我的收藏
    async getMineCollect() {
      let data = await this.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/collect`,
      );
      this.myCollect = data.data.splice(0, 5);
    },
    // 跳转
    toMemberCommunity(tab) {
      if (this.$store.state.token) {
        this.$router.push({
          name: "MemberCommunity",
          query: {
            tab,
          },
        });
      } else {
        this.$router.push({
          name: "Login",
        });
      }
    },
    //跳转圈子
    toCircle(id) {
      this.$router.push({
        name: "CommunityGroupShow",
        params: { id },
      });
    },
    //加入/退出圈子
    async toJoin(id, isAdd) {
      if (isAdd == 1) {
        await this.$http.get(
          `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/outGroup/${id}`,
        );
      } else {
        await this.$http.get(
          `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/addGroup/${id}`,
        );
      }
      this.getGroupList();
    },
    //跳转其他帖子
    toOther(item) {
      this.$router.push({
        name: "CommunityDetail",
        params: {
          id: item.post_id,
          group_id: item.group_id,
          plate_id: item.plate_id,
          type: 2,
        },
      });
    },
    onGroupImageLoad($event) {
      let width = $event.target.naturalWidth;
      let height = $event.target.naturalHeight;
      if (width < 72 || height < 72) {
        return;
      }
      let widthPercent = 72 / width;
      let heightPercent = 72 / height;
      let percent = widthPercent > heightPercent ? widthPercent : heightPercent;
      width = parseInt(width * percent);
      height = parseInt(height * percent);
      $event.target.style.width = width + "px";
      $event.target.style.height = height + "px";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.forum {
  padding: 24px 0;
  background-color: #f5f7f9;
  overflow: hidden;
  .bread {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
  }
  .forum-box {
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    .left {
      float: left;
      width: 896px;
      border-radius: 5px;
      box-sizing: border-box;
      overflow: hidden;
      .group-box {
        background: #fff;
        padding: 13px 24px 1px 24px;
        .title {
          display: flex;
          justify-content: space-between;
          height: 30px;
          line-height: 30px;
          span {
            font-size: 16px;
            font-family: PingFangSC-Medium;
            color: #20242a;
          }
          a {
            padding-right: 11px;
            background: url("~@/assets/images/icon_fourm_right_arrow.png") right
              center no-repeat;
            background-size: 6px 11px;
            font-size: 16px;
            color: #5b6066;
          }
        }
        .group {
          margin-top: 13px;
          .el-row {
            margin: 0 !important;
          }
          .el-col {
            margin-bottom: 24px;
            border: 1px solid #e6e6e6;
            border-radius: 5px;
            padding: 0 !important;
            margin-right: 22px;
            width: auto !important;
            box-sizing: border-box;
            &:nth-child(3n) {
              margin-right: 0;
            }
            &:hover {
              box-shadow: 0px 1px 10px 0px #ebebeb;
              border-color: transparent;
            }
            .grid-content {
              width: 266px;
              height: 112px;
              box-sizing: border-box;
              position: relative;
              top: 0;
              display: block;
              padding: 18px 15px 19px 15px;
              border-radius: 4px;
              background-color: #fff;
              display: flex;
              align-items: center;
              .img {
                width: 72px;
                height: 72px;
                border-radius: 10px;
                overflow: hidden;
                flex-shrink: 0;
              }
              .content {
                margin-left: 15px;
                width: auto;
                overflow: hidden;
                align-self: start;
                .name {
                  height: 22px;
                  font-size: 14px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: rgba(32, 36, 42, 1);
                  line-height: 22px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  margin-bottom: 4px;
                }
                .message {
                  display: flex;
                  font-size: 13px;
                  color: #999;
                  .comment {
                    margin-right: 8px;
                  }
                }
                .isJoin {
                  font-size: 14px;
                  color: $primary-color;
                  padding-top: 10px;
                  cursor: pointer;
                }
              }
              .btn {
                position: absolute;
                left: 50%;
                bottom: -13px;
                display: none;
                width: 66px;
                height: 26px;
                margin-left: -33px;
                border-radius: 14px;
                background-color: $primary-color;
                text-align: center;
                font-size: 13px;
                color: #fff;
                line-height: 26px;
              }
            }
          }
        }
      }
    }
    .right {
      margin-left: 912px;
      width: auto;
      .look-day {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 135px;
        background: #fff;
        border-radius: 5px;
        div {
          flex: 1;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        .today {
          position: relative;
          &::after {
            content: "";
            width: 1px;
            height: 40px;
            background-color: #edf1f2;
            position: absolute;
            right: 0;
            top: 47px;
          }
        }
        .num {
          margin: 0 0 15px;
          font-size: 30px;
          font-family: PingFangSC-Medium;
          color: #20242a;
          line-height: 30px;
        }
        .day {
          line-height: 16px;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          color: #b7b7b7;
        }
      }
      .post {
        display: block;
        width: 100%;
        margin: 20px 0 0;
        padding: 0 0 0 130px;
        height: 60px;
        line-height: 60px;
        border: none;
        box-shadow: 0px 6px 20px 0px $primary-color-04,
          0px 13px 33px 0px rgba(0, 0, 0, 0.04);
        border-radius: 32px;
        background: url("~@/assets/images/icon_fourm_post.png") 180px center
          no-repeat #fff;
        background-size: 18px 18px;
        text-align: left;
        font-size: 20px;
        color: #595959;
        outline: none;
        cursor: pointer;
        &:hover {
          background: url("~@/assets/images/icon_fourm_post_active.png") 180px
            center no-repeat $primary-color;
          background-size: 18px 18px;
          color: #fff;
        }
      }
      .mine {
        margin-bottom: 16px;
        padding: 0 20px;
        background-color: #fff;
        &.no-mart {
          margin-top: 0;
        }
        .title {
          position: relative;
          height: 50px;
          font-size: 16px;
          color: #333;
          line-height: 50px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: bold;
          span {
            font-size: 14px;
            color: #666;
            margin-right: 10px;
            font-weight: 400;
          }
          i {
            position: absolute;
            top: 18px;
            right: 0;
            display: block;
            width: 6px;
            height: 12px;
            background: url("~@/assets/images/icon_fourm_right_arrow.png")
              center no-repeat;
            background-size: 100% 100%;
          }
        }
        .no-login {
          display: block;
          height: 147px;
          background: url("~@/assets/images/community/no_login_bg.png") center
            no-repeat #fff;
          background-size: 221px 154px;
          line-height: 250px;
          text-align: center;
          font-size: 14px;
          color: #999;
          margin-top: 20px;
          span {
            color: $primary-color;
            margin-left: 22px;
          }
          .emptyTip {
            color: #999;
          }
        }
        .list {
          a {
            display: block;
            margin: 15px 0;
            line-height: 14px;
            font-size: 14px;
            color: #333;
          }
        }
      }
      .m-group {
        overflow: hidden;
        .grid-content {
          display: flex;
          padding: 16px 0;
          border-bottom: 1px solid #f1f1f1;
          &:last-child {
            border: 0;
          }
          .img {
            width: 70px;
            height: 70px;
            img {
              display: block;
              width: 70px;
              height: 70px;
              border-radius: 4px;
            }
          }
          .content {
            margin-left: 15px;
            flex: 1;
            .name {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 14px;
              font-family: PingFangSC-Medium;
              color: #333;
            }
            .message {
              display: flex;
              align-items: center;
              margin-top: 12px;
              font-size: 13px;
              color: #8c8c8c;
              line-height: 12px;
              .people {
                margin-left: 12px;
              }
            }
          }
        }
      }
      .myPost {
        margin-top: 16px;
      }
    }
  }
}
</style>
